import { TopBarChart } from "./TopBarChart";
import React, { useState, useEffect } from "react";
import { cardStyle } from "../../../helpers/Executive-Dashboard/styleFormat";
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { fetchTopCustomer, fetchTopProduct } from "../../../services/salesInvoiceService";
import { integration } from "../../../helpers/Executive-Dashboard/integration";
import { LoadingOverlay } from "./LoadingOverlay";

export const TopStatsCard = React.memo(({ title, icon, data, color, sourceLabel, topType, branch }) => {
    const [viewMode, setViewMode] = useState('permonth'); // all, permonth, peryear
    const now = new Date();
    const [month, setMonth] = useState(now.getMonth() + 1);
    const [year, setYear] = useState(now.getFullYear());
    const [loading, setLoading] = useState(false);
    const [topData, setTopData] = useState(null);
    
    // Formatting date range depending on view mode
    const getMonthName = (m) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[m - 1];
    };
    
    const getDaysInMonth = (m, y) => new Date(y, m, 0).getDate();
    
    let dateStr = '';
    if (viewMode === 'permonth') {
        dateStr = `1 ${getMonthName(month)} - ${getDaysInMonth(month, year)} ${getMonthName(month)} ${year}`;
    } else if (viewMode === 'year') {
        dateStr = `${year}`;
    }

    useEffect(() => {
        setLoading(true);
        const load = async () => {
            try {
                const config = sourceLabel === 'PT. Suma Alpha Indonesia' ? integration('SUMA') : integration('GP');
                const result = await (topType === 'customer' ? fetchTopCustomer(viewMode, month, year, config, branch) : fetchTopProduct(viewMode, month, year, config, branch));
                setTopData(result);
                setLoading(false);
            } catch (error) {
                setTopData(data);
                setLoading(false);
            }
        };
        load();
    }, [viewMode, month, year, sourceLabel, data, branch]);
    
    const handlePrev = () => {
        if (viewMode === 'permonth') {
            if (month === 1) { setMonth(12); setYear(y => y - 1); }
            else setMonth(m => m - 1);
        } else if (viewMode === 'year') {
            setYear(y => y - 1);
        }
    };
    
    const handleNext = () => {
        if (viewMode === 'permonth') {
            if (month === 12) { setMonth(1); setYear(y => y + 1); }
            else setMonth(m => m + 1);
        } else if (viewMode === 'year') {
            setYear(y => y + 1);
        }
    };

    return (
        <div style={{ ...cardStyle, padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: viewMode == 'all' ? '372px' : '400px' }}>
            <div style={{ padding: '12px 20px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0, fontSize: '13px', fontWeight: '700', color: '#0f172a', display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                    {icon} {title}
                </h3>
                <div style={{ display: 'flex', background: '#f1f5f9', borderRadius: '8px', padding: '4px' }}>
                    <button
                        onClick={() => setViewMode('all')}
                        style={{
                            padding: '6px 14px', borderRadius: '6px', border: 'none',
                            fontSize: '12px', fontWeight: '600', cursor: 'pointer',
                            background: viewMode === 'all' ? '#fff' : 'transparent',
                            color: viewMode === 'all' ? '#0ea5e9' : '#64748b',
                            boxShadow: viewMode === 'all' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                            transition: 'all 0.2s'
                        }}>
                        All
                    </button>
                    <button
                        onClick={() => setViewMode('permonth')}
                        style={{
                            padding: '6px 14px', borderRadius: '6px', border: 'none',
                            fontSize: '12px', fontWeight: '600', cursor: 'pointer',
                            background: viewMode === 'permonth' ? '#fff' : 'transparent',
                            color: viewMode === 'permonth' ? '#0ea5e9' : '#64748b',
                            boxShadow: viewMode === 'permonth' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                            transition: 'all 0.2s'
                        }}>
                        Per Month
                    </button>
                    <button
                        onClick={() => setViewMode('year')}
                        style={{
                            padding: '6px 14px', borderRadius: '6px', border: 'none',
                            fontSize: '12px', fontWeight: '600', cursor: 'pointer',
                            background: viewMode === 'year' ? '#fff' : 'transparent',
                            color: viewMode === 'year' ? '#0ea5e9' : '#64748b',
                            boxShadow: viewMode === 'year' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                            transition: 'all 0.2s'
                        }}>
                        Per Year
                    </button>
                </div>
            </div>
            
            {viewMode !== 'all' && (
            <div style={{ padding: '10px 20px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <div style={{ color: '#0ea5e9', fontWeight: '600', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div 
                        onClick={handlePrev}
                        style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            width: '24px', height: '24px', borderRadius: '6px', 
                            backgroundColor: '#fff', cursor: 'pointer',
                            fontSize: '14px', fontWeight: 'bold', color: '#64748b',
                            transition: 'all 0.2s', border: '1px solid #e2e8f0'
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; e.currentTarget.style.color = '#334155'; }}
                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#fff'; e.currentTarget.style.color = '#64748b'; }}
                    >
                        <ArrowLeft size={14} />
                    </div>
                    
                    <span style={{ minWidth: '130px', textAlign: 'center' }}>
                         {dateStr}
                    </span>
                    <div 
                        onClick={handleNext}
                        style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            width: '24px', height: '24px', borderRadius: '6px', 
                            backgroundColor: '#fff', cursor: 'pointer',
                            fontSize: '14px', fontWeight: 'bold', color: '#64748b',
                            transition: 'all 0.2s', border: '1px solid #e2e8f0'
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; e.currentTarget.style.color = '#334155'; }}
                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#fff'; e.currentTarget.style.color = '#64748b'; }}
                    >
                        <ArrowRight size={14} />
                    </div>
                </div>
            </div>
            )}
            
            <div style={{ flex: 1, position: 'relative', marginTop: viewMode === 'all' ? '14px' : '0' }}>
                <LoadingOverlay active={loading} />
                <div style={{ padding: '0px 20px 20px 20px' }}>
                    <TopBarChart data={topData} color={color} />
                </div>
            </div>
        </div>
    );
});